import * as styledComponents from "styled-components";
var _a = 
// @ts-ignore
styledComponents, styled = _a.default, css = _a.css, ThemeProvider = _a.ThemeProvider;
export { css, ThemeProvider };
export default styled;
